import { Autocomplete, FormControl, TextField } from "@mui/material";
import classes from './CustomAutocomplete.module.css'
import { Option } from "../../../model/models-module";

  
interface CustomAutocompleteProps {
    label: string;
    value: Option | undefined;
    options: Option[];
    onChange: (value: Option | undefined) => void;
}

const CustomAutocomplete = ({ label, value, options, onChange }: CustomAutocompleteProps) => (
    <FormControl className={classes['select-filter']} size="small">
      <span className={classes['setting-attr-title']}>{label}</span>
      <Autocomplete
        value={value || null}
        options={options}
        getOptionLabel={(option) => option.description}
        isOptionEqualToValue={(option, value) => option.id === value?.id}
        onChange={(_, newValue) => onChange(newValue ?? undefined)}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Seleccionar"
            className={classes['select-option']}
            variant="outlined"
            size="small"
          />
        )}
      />
    </FormControl>
  );

export default CustomAutocomplete